import { useMemo, useState } from "react";
import ActionMenu from "../../actionMenus/action-menu";
import arrowUpIcon from "../../../assets/componentsIcons/listings/arrow_up.svg";
import arrowUpBlueIcon from "../../../assets/componentsIcons/listings/arrow_up_blue.svg";
import dropdownIcon from "../../../assets/componentsIcons/dropdown/dropdown.svg";
import paymentIcon from "../../../assets/Payment-Icon.svg";
import notesIcon from "../../../assets/componentsIcons/dropdown/doc.svg";
import React from "react";
import SimpleSpinner from "../../../components/loader";
import InvoiceIcon from "../../../assets/svgs/payables/arrowDownIcon";
import EmailIcon from "../../../assets/svgs/receivableIcons/emailIcon";
import PhoneIcon from "../../../assets/svgs/receivableIcons/phoneIcon";
import { PaymentDueAccountVM } from "@propertelligent/client-api";
import PayableIcon from "../../../assets/svgs/payableIcon";
import { useNavigate } from "react-router-dom";
import RightSideModal from "../../Modal/right-side-modal";
import WaivePaymentList from "../../payments/WaivePaymentList";
import UtilHelper from "../../../utils/UtilHelper";
import CurrencyTooltip from "../../../components/currencytooltip/CurrencyTooltip";

interface ReceivableDetailCardProps {
  Id?: any;
  IsFooter?: boolean;
  data?: PaymentDueAccountVM;
  loading?: boolean;
  isBorderRadius?: boolean;
  onRefresh?: () => void;
}

const ReceivableDetailCard: React.FC<ReceivableDetailCardProps> = ({
  Id,
  IsFooter = true,
  data,
  loading = false,
  isBorderRadius = true,
  onRefresh,
}) => {

  const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [tenantId, setTenantId] = useState<number>(0);

  // Constants for menu items
  const MENU_ITEMS = [
    {
      icon: paymentIcon,
      label: "Post Payment",
      customaction: (payeeAccId: number) => navigate(`/payment/settle-payables-payment/${payeeAccId}`),
      isDivider: false,
      isDestructive: false,
    },
    {
      icon: paymentIcon,
      label: "Waive Payment",
      customaction: (entityId: number) => {
        setTenantId(entityId);
        setIsModalOpen(true);
      },
      isDivider: false,
      isDestructive: false,
    },
  ];

  const menuItems = useMemo(() => MENU_ITEMS, []);



  if (loading) {
    return <SimpleSpinner myClassName="Icon50" isFullPage={true} />;
  }

  if (!data) {
    return null;
  }

  

  return (
    <>
      {data.paidFlowTypeId == 1 ? (
        <div
          id={Id}
          className={`listing-card payables ${isBorderRadius ? '' : 'no-border-radius'}`}
        >
          {/* Top section */}
          <div className="listing-card-header">
            <div className="listing-image-container">
              <PayableIcon className="listing-image" width="36px" height="36px" />
            </div>
            <div className="listing-details">
              <div className="listing-info-container">
                <div className="listing-info">
                  <h3 className="listing-address">{data.payerPayeeName}</h3>
                  <p className="listing-type">{data.formatted.PayeeAccountTypeId}</p>
                </div>

                <div className="financial-metrics">
                  <div className="metric">
                    <p className={`metric-value negative`}>
                      ${data.formatted.Amount}
                    </p>
                    <p className="metric-label">Amount</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {IsFooter && (
            <>
              <div className="separator-horizontal" />
              <div className="listing-card-footer">
                <div className="listing-stats">
                  <div className="stat">
                    <InvoiceIcon fill={'#4B5563'} className="stat-icon" width="24" height="24" />
                    <span className="stat-text">
                      Outstanding Invoices: {data.invoicesCount}
                    </span>
                  </div>
                </div>

                <div className="footer-actions">

                  <div className="highlight-value">
                    <img
                      src={arrowUpIcon}
                      alt="Trend"
                      width={16}
                      height={16}
                      className="highlight-icon"
                    />
                    <span className="highlight-text text-danger">Past Due: ${data.formatted.PastDue}</span>
                  </div>

                  <ActionMenu
                    menuItems={menuItems}
                    Id={data.id}
                    trigger={
                      <button className="action-button">
                        <img
                          src={dropdownIcon}
                          alt="More options"
                          width={20}
                          height={20}
                          className="action-icon"
                        />
                      </button>
                    }
                  />
                </div>
              </div>
            </>
          )}
        </div>
      ):(
        <div id={Id} className="listing-card">
          {/* Top section */}
          <div className="listing-card-header">
            <div className="tenant-avatar">
              <div className="tenant-initials">{UtilHelper.getInitials(data.payerPayeeName)}</div>
            </div>
            <div className="listing-details">
              <div className="listing-info-container">
                <div className="listing-info">
                  <h3 className="listing-address">{data.payerPayeeName}</h3>
                  <p className="listing-type">{data.streetAddress}</p>
                </div>

                <div className="financial-metrics">
                  <div className="metric">
                    <CurrencyTooltip
                      content={data?.formatted?.AmountRaw}
                      formatted={data?.formatted?.Amount}
                      >
                        <p className={`metric-value negative`}>
                          {data.formatted.Amount}
                        </p>
                    </CurrencyTooltip>
                    <p className="metric-label">{"Amount"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {IsFooter && (
            <>
              <div className="separator-horizontal" />
              <div className="listing-card-footer">
                <div className="listing-stats">
                  {data.email && (
                    <div className="stat">
                      <EmailIcon fill={'#4B5563'} className="stat-icon" width="24" height="24" />
                      <span className="stat-text">
                        {"Email"}: {data.email}
                      </span>
                    </div>
                  )}
                  {data.phoneNumber && (
                    <div className="stat">
                      <PhoneIcon fill={'#4B5563'} className="stat-icon" width="24" height="24" />
                      <span className="stat-text">
                        {"Phone"}: {data.formatted?.PhoneNumber}
                      </span>
                    </div>
                  )}
                </div>

                <div className="footer-actions">
                 {/* Past Due */}
                {Number(String(data?.formatted?.PastDueRaw).replace(/,/g, "")) > 0 && (
                  <div className="highlight-value negative">
                    <img
                      src={arrowUpIcon}
                      alt="Trend"
                      width={16}
                      height={16}
                      className="highlight-icon"
                      loading="lazy"
                    />
                    <span className="highlight-text">Past Due:{" "}
                      <CurrencyTooltip
                        content={data?.formatted?.PastDueRaw}
                        formatted={data?.formatted?.PastDue}
                        >
                          <span>{data?.formatted?.PastDue}</span>
                      </CurrencyTooltip>
                    </span>
                  </div>
                )}

                {/* Due in 30 Days */}
                {Number(String(data?.formatted?.DueIn30DaysRaw).replace(/,/g, "")) > 0 && (
                  <div className="highlight-value info">
                    <img
                      src={arrowUpBlueIcon}
                      alt="Trend"
                      width={16}
                      height={16}
                      className="highlight-icon"
                      loading="lazy"
                    />
                    <span className="highlight-text">Due in 30 Days:{" "}
                      <CurrencyTooltip
                        content={data?.formatted?.DueIn30DaysRaw}
                        formatted={data?.formatted?.DueIn30Days}
                        >
                          <span>{data?.formatted?.DueIn30Days}</span>
                      </CurrencyTooltip>
                    </span>
                  </div>
                )}

                  <ActionMenu
                    menuItems={menuItems}
                    Id={data.payeeAccountId}
                    entityId={data.entityId}
                    trigger={
                      <button className="action-button">
                        <img
                          src={dropdownIcon}
                          alt="More options"
                          width={20}
                          height={20}
                          className="action-icon"
                        />
                      </button>
                    }
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {tenantId > 0 && (
        <RightSideModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Waive Payment"
          isFooterHidden={false}
          buttonlabel="Waive Payment"
          formId="WaivePayment"
          maxWidth={500}>
          <WaivePaymentList
            tenantId={tenantId}
            setIsModalOpen={setIsModalOpen}
            fetchData={() => {
              if (onRefresh) onRefresh();
            }}
          />
        </RightSideModal>
      )}
    </>
  );
};

export default ReceivableDetailCard;